/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTicketTypeDto } from '../../models/create-ticket-type-dto';
import { TicketTypeDto } from '../../models/ticket-type-dto';

export interface AdminTicketTypeControllerUpdate$Params {
  id: string;
      body: CreateTicketTypeDto
}

export function adminTicketTypeControllerUpdate(http: HttpClient, rootUrl: string, params: AdminTicketTypeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketTypeDto>> {
  const rb = new RequestBuilder(rootUrl, adminTicketTypeControllerUpdate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketTypeDto>;
    })
  );
}

adminTicketTypeControllerUpdate.PATH = '/api/ticket-type/admin/{id}';
